document.addEventListener('DOMContentLoaded', () => {
    initializeSlider();
});

function initializeSlider() {
    const slides = document.querySelectorAll('.rolex-slide');

    if (slides.length === 0) {
        console.error('No slides found!');
        return;
    }

    let currentSlide = 0;
    let slidesToShow = 1;
    let totalPages = Math.ceil(slides.length / slidesToShow);

    window.addEventListener('resize', () => {
        totalPages = Math.ceil(slides.length / slidesToShow);
        createIndicators(totalPages, goToPage);
        updateSlider(currentSlide, slidesToShow);
        updateIndicators(currentSlide, slidesToShow);
    });

    document.querySelector('.rolex-slide-next').addEventListener('click', () => {
        moveSlide(1);
    });

    document.querySelector('.rolex-slide-prev').addEventListener('click', () => {
        moveSlide(-1);
    });

    function moveSlide(direction) {
        if (direction === -1 && currentSlide > 0) {
            currentSlide -= slidesToShow;
        } else if (direction === 1 && currentSlide + slidesToShow < slides.length) {
            currentSlide += slidesToShow;
        }
        updateSlider(currentSlide, slidesToShow);
        updateIndicators(currentSlide, slidesToShow);
    }

    function updateSlider(currentSlide, slidesToShow) {
        currentSlide = Math.max(0, Math.min(currentSlide, slides.length - slidesToShow));
        const slider = document.querySelector('.rolex-slider');
        const slideWidth = 100 / slidesToShow;
        slider.style.transform = `translateX(-${currentSlide * slideWidth}%)`;

        const prevButton = document.querySelector('.rolex-slide-prev');
        const nextButton = document.querySelector('.rolex-slide-next');
        if (window.innerWidth >= 768) {
            prevButton.style.display = currentSlide > 0 ? 'block' : 'none';
            nextButton.style.display = (currentSlide + slidesToShow) < slides.length ? 'block' : 'none';
        } else {
            prevButton.style.display = 'none';
            nextButton.style.display = 'none';
        }
    }

    function createIndicators(totalPages, goToPage) {
        const indicatorContainer = document.querySelector('.rolex-slide-indicators');
        indicatorContainer.innerHTML = '';
        for (let i = 0; i < totalPages; i++) {
            const indicator = document.createElement('div');
            indicator.classList.add('rolex-slide-indicator');
            indicator.addEventListener('click', () => goToPage(i));
            indicatorContainer.appendChild(indicator);
        }
    }

    function updateIndicators(currentSlide, slidesToShow) {
        const indicators = document.querySelectorAll('.rolex-slide-indicator');
        const currentPage = Math.floor(currentSlide / slidesToShow);
        indicators.forEach((indicator, index) => {
            if (index === currentPage) {
                indicator.classList.add('rolex-slide-indicator-active');
            } else {
                indicator.classList.remove('rolex-slide-indicator-active');
            }
            if( slides[currentPage].dataset.brightness === 'dark' ){
                indicator.classList.add('dark');
            } else {
                indicator.classList.remove('dark');
            }
        });
    }

    function goToPage(page) {
        currentSlide = page * slidesToShow;
        updateSlider(currentSlide, slidesToShow);
        updateIndicators(currentSlide, slidesToShow);
    }

    createIndicators(totalPages, goToPage);
    updateSlider(currentSlide, slidesToShow);
    updateIndicators(currentSlide, slidesToShow);
}
